import { render, staticRenderFns } from "./EmployeeField.vue?vue&type=template&id=0bf4a0de"
import script from "./EmployeeField.vue?vue&type=script&lang=js"
export * from "./EmployeeField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports